import Commons from "./commons";

export default class BulkAction extends Commons {
  constructor() {
    super();
    this.configure();
  }

  configure() {
    this.ui.bulkCount = "#bulk_count";
    this.ui.jsBulkTotalCount = ".search-count";
    this.ui.jsTableBody = ".js-table-body";
    this.ui.jsBulkCheck = ".js-bulk-check";
    this.ui.jsMassiveBulkCheck = ".js-massive-bulk-check";
    this.ui.jsBulkCheckEditAll = ".js-bulk-check-edit-all";
  }

  selected(temporal_state_update_path, temporal_state_update_all_path) {
    const operation = this;
    const total = parseInt($(operation.ui.jsBulkTotalCount).text());
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    // Individual checkbox
    $(document).on("click", operation.ui.jsBulkCheck, function () {
      let bulk_count = Number($(operation.ui.bulkCount).val());
      const selects = $(operation.ui.jsTableBody).find("input:checkbox:checked").length;

      $(operation.ui.jsMassiveBulkCheck).prop("checked", selects > 0);

      bulk_count += $(this).prop("checked") ? 1 : -1;
      $(operation.ui.bulkCount).val(bulk_count);

      $.ajax({
        type: "POST",
        url: temporal_state_update_path,
        contentType: "application/json",
        headers: {
          'X-CSRF-Token': token  // aquí va el token
        },
        data: JSON.stringify({ id: $(this).val(), multiple: false }),
      });

      operation.updateCheck();
    });

    // Massive checkbox
    $(document).on("click", operation.ui.jsMassiveBulkCheck, function () {
      const is_checked = $(this).prop("checked");
      const checked = $(".js-table-body").find("input:checkbox:checked").length;
      const vals = $(operation.ui.jsBulkCheck)
        .map((_, el) => Number($(el).val()))
        .get();

      const path = is_checked
        ? temporal_state_update_path
        : temporal_state_update_all_path;
      const status_params = is_checked;
      const bulk_count = is_checked ? vals.length - checked : 0;

      $(operation.ui.bulkCount).val(bulk_count);

      $.ajax({
        type: "POST",
        url: path,
        headers: {
          'X-CSRF-Token': token  // aquí va el token
        },
        data: { values: vals, status: status_params, multiple: true },
        success: () => {
          $(operation.ui.jsBulkCheck).prop("checked", is_checked);
        },
      });

      $("#special-bulk-td").toggle(is_checked);
      $(operation.ui.jsBulkCheckEditAll).toggle(is_checked);
      operation.updateCheck();
    });

    // Edit all
    $(document).on("click", operation.ui.jsBulkCheckEditAll, function () {
      const params = $("#check_all").data("q");
      const bulk_count = parseInt($(operation.ui.jsBulkTotalCount).text());
      $(operation.ui.bulkCount).val(bulk_count);

      bootbox.dialog({
        centerVertical: true,
        closeButton: false,
        message:
          '<p class="text-center"><i class="fas fa-sync fa-spin fa-4x"></i></p>' +
          "<h5 class='text-center'>Processing...</h5>",
      });

      $.ajax({
        type: "POST",
        url: temporal_state_update_all_path,
        headers: {
          'X-CSRF-Token': token  // aquí va el token
        },
        data: { q: params["q"], status: true },
      })
        .fail(() => $(".bootbox.modal").modal("hide"))
        .done(() => {
          $(".bootbox.modal").modal("hide");
          $(operation.ui.jsBulkCheck).prop("checked", true);
          $(operation.ui.jsMassiveBulkCheck).prop("checked", true);
        })
        .always(() => {
          setTimeout(() => $(".bootbox.modal").modal("hide"), 500);
        });

      operation.updateCheck();
    });
  }

  updateCheck() {
    const operation = this;
    const bulk_count = Number($(operation.ui.bulkCount).val());
    const total = parseInt($(operation.ui.jsBulkTotalCount).text());

    $(operation.ui.jsBulkCheckEditAll).toggleClass("d-none", bulk_count === total);
    $(operation.ui.jsMassiveBulkCheck).prop("checked", bulk_count > 0);
    $("#special-bulk-td").toggle(bulk_count > 0);
    $("#special-bulk-td span.text").text(`${bulk_count} records selected.`);
  }

  execute(elementID, message, url, method) {
    const operation = this;
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    $(elementID).on("click", function () {
      const params = $(operation.ui.jsBulkCheckEditAll).data("q");
      const actionUrl = new URL(url, window.location.href);
      const countUrl = new URL("count_selected", actionUrl).pathname;
      let count = 0;

      $.ajax({
        method: "GET",
        url: countUrl,
        headers: {
          'X-CSRF-Token': token  // aquí va el token
        },
        dataType: "json",
        async: false,
      }).done((data) => (count = data.count));

      bootbox.confirm({
        title: "Confirm Action",
        message: `${message} ${count} records selected.`,
        buttons: {
          confirm: { label: "Accept", className: "btn-success" },
          cancel: { label: "Cancel", className: "btn-danger" },
        },
        callback: function (result) {
          if (!result) return;
          bootbox.dialog({
            centerVertical: true,
            closeButton: false,
            title: "Processing",
            message:
              '<p class="text-center"><i class="fas fa-sync fa-spin fa-4x"></i></p>' +
              "<h5 class='text-center'>Processing...</h5>" +
              "<h5 class='text-center'>Please wait, The Bulk Action is being processed</h5>",
          });
          url = url.replace(/&amp;/g, "&");

          $.ajax({
            method, url,
            headers: {
              'X-CSRF-Token': token  // aquí va el token
            }, data: params
          }).always(() => {
            setTimeout(() => $(".bootbox.modal").modal("hide"), 500);
          });
        },
      });
    });
  }
}
